module.exports = __webpack_public_path__ + "img/img20.54584614.svg";